/**
 * Translation slice (SCRUM-1951, RTK bundle 2) — the former switch reducer
 * translationReducer.js as createSlice. Behaviour-preserving: every case answers
 * the same legacy action type string (types.js) that translationActions.js and
 * pageServices/pagesSlice.ts (GET_PAGE_BY_ID) dispatch, and returns the same
 * state — including the `error` field GET_ERRORS adds, which the initial state
 * does not declare. The actions module is unchanged, so no importer changes.
 * Characterised by tests/integration/reducers/reviewPublishingReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import { legacyCases } from "../legacyCases";
import {
  TRANSLATE,
  GET_ALL_TRANSLATED_PAGES,
  DELETE_TRANSLATE_PAGE,
  GET_PAGE_BY_ID,
  GET_ERRORS,
} from "./types";

// The four fields stay `any`, as in the JSDoc this replaces: the translation
// screens (TranslatePagesContainer, UpdateTranslatePageContainer, being
// converted in SCRUM-2044) read fields no shared type declares yet
// (`target_language`, `requires_review`, `parentPage`). They narrow with them.
type TranslationState = {
  translatedpages: any[];
  pagetranslated: any;
  page: any;
  error?: any;
};

const initialState: TranslationState = {
  translatedpages: [],
  pagetranslated: {},
  page: {},
};

const translationCases = {
  [GET_ALL_TRANSLATED_PAGES]: "translatedpages" as const,
  [DELETE_TRANSLATE_PAGE]: (state: TranslationState, payload: string) => ({
    ...state,
    translatedpages: state.translatedpages.filter((page) => page._id !== payload),
  }),
  [TRANSLATE]: "pagetranslated" as const,
  [GET_PAGE_BY_ID]: "page" as const,
  [GET_ERRORS]: "error" as const,
};

const translationSlice = createSlice({
  name: "translatedpages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    legacyCases(builder, translationCases);
  },
});

export default translationSlice.reducer;
